<template>
    <div class="wishlist-duplicate-list">
        <input             
            type="text" 
            name="listname" 
            v-model="newListName"
            @input="clearError"
            placeholder="Enter name for list"
            class="wishlist-duplicate-list__input-box"
            required
        />
        <div class="wishlist-duplicate-list__error" v-if="error">{{ error }}</div>
        <div class="wishlist-duplicate-list__cta-section">
            <button
                class="btn btn--secondary btn--medium wishlist-duplicate-list__cta-save"
                @click="handleDuplicateList"
                :disabled="!newListName.trim() || isProcessing"
            >
                <span :class="{'wishlist--processing': isProcessing}" class="wishlist__cta-loader">SAVE</span>
            </button>
            <button
                class="btn wishlist-duplicate-list__cta-cancel" 
                @click="handleCancelClick"
            >
                Cancel
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, toRefs } from 'vue';
import { useStore } from 'vuex';
import { duplicateWishlist } from '../../api';

const props = defineProps({
    onCancel: {
        type: Function,
        default: () => { }
    },

    showWishlistContentPage: {
        type: Function,
        default: () => { }
    },

    selectedWishlistDetails: {
        type: Object,
        default: {}
    },

    allWishlist: {
        type: Array,
        default: []
    }
});

const { selectedWishlistDetails, allWishlist } = toRefs(props);

const store = useStore();

const newListName = ref(`${selectedWishlistDetails.value.lname} copy`);
const error = ref('');
const isProcessing = ref(false);

const handleCancelClick = () => {
    props.onCancel();
};

const handleDuplicateList = async () => {
    try {
        const newList = newListName.value.trim();

        const validationError = validateInput(newList);
        if (validationError) {
            error.value = validationError;
            return;
        }

        isProcessing.value = true;
        const listResponse = await duplicateWishlist(newList, selectedWishlistDetails.value.lid);
        if (listResponse) {
            await store.dispatch('fetchWishlistItems');
            handleCancelClick();
            props.showWishlistContentPage(false);
        }
    } catch (error) {
        console.error('Error duplicating list', error);
    } finally {
        isProcessing.value = false;
    }
};

const isWishlistAlreadyExist = (val) => {
    return allWishlist.value.some(item => 
        item.lname.toLowerCase() === val.toLowerCase()
    );
};

const validateInput = (listName) => {
    let error = '';

    if (isWishlistAlreadyExist(listName)) {
        error = 'Wishlist already exists';
    } else if (listName.length < 3) {
        error = 'Please enter at least 3 characters';
    } else if (listName.length > 50) {
        error = 'Please enter no more than 50 characters';
    } else if (!/^[A-Za-z0-9_!&$#@ ,’.'-]*$/.test(listName)) {
        error = 'Only these special characters allowed: _!&$#@ ,’.\'-';
    }

    return error;
}

const clearError = () => {
    error.value = '';
};

</script>
